module.exports = {"321203001":"口岸街道","321203002":"刁铺街道","321203003":"许庄街道","321203004":"凤凰街道","321203005":"寺巷街道","321203006":"明珠街道","321203007":"沿江街道","321203100":"永安洲镇","321203101":"白马镇","321203103":"胡庄镇","321203104":"大泗镇","321203105":"野徐镇","321203400":"泰州港经济开发区","321203401":"医药产业园","321203402":"电子信息产业园","321203403":"数据产业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/321203.json
// module id = 1029
// module chunks = 0